import React from 'react';
import { ViewProps } from 'react-native';
import styled from 'styled-components/native';
import { TouchableWithoutFeedback } from 'react-native';
import { Caption } from './Typography';

const StyledTrackView = styled.View<{ active: boolean }>`
  height: 18px;
  width: 32px;
  background-color: ${p => (p.active ? '#887ceb' : '#394159')};
  border-radius: 40px;
`;

const StyledThumbView = styled.View<{ active: boolean }>`
  position: absolute;
  height: 18px;
  width: 18px;
  border-radius: 40px;
  background-color: white;
  border-color: ${p => (p.active ? '#887ceb' : '#394159')};
  border-width: 2px;
  ${p => (p.active ? 'right: 12px;' : 'left: 12px;')};
`;

const StyledToggleLabelContainer = styled.View`
  flex-direction: row;
  align-items: center;
`;

const StyledToggleContainer = styled.View`
  width: 55px;
  height: 30px;
  justify-content: center;
  align-items: center;
`;

const StyledP = styled(Caption)`
  margin-left: 12px;
`;

export type CustomToggleSwitchProps = ViewProps & {
  value: boolean;
  onToggle: () => void;
  label?: string;
  disabled?: boolean;
  testID?: string;
};

const CustomToggleSwitch: React.FC<CustomToggleSwitchProps> = ({
  value,
  onToggle,
  label,
  disabled,
  ...props
}) => {
  return (
    <TouchableWithoutFeedback
      testID={props.testID}
      disabled={disabled}
      onPress={() => {
        if (!disabled && typeof onToggle === 'function') onToggle();
      }}
    >
      <StyledToggleLabelContainer>
        <StyledToggleContainer style={props.style}>
          <StyledTrackView active={value} />
          <StyledThumbView
            style={{
              shadowOffset: { width: 0, height: 1.02 }
            }}
            active={value}
          />
        </StyledToggleContainer>
        {!!label && <StyledP>{label}</StyledP>}
      </StyledToggleLabelContainer>
    </TouchableWithoutFeedback>
  );
};

export default CustomToggleSwitch;
